var exports = {
  "k": "x127c5a35--795f8a--container",
  "n": "x127c5a35--795f8a--link",
};

module.exports = exports;
